import React from "react"
import { useSidebarStore } from "@src/hooks/useStore"
import Button from "@components/button"
import { ReactComponent as Plus } from "@svgs/plus.svg"
import SidebarContent from "@src/components/sidebar/content"
import ProductFilter from "../product-filter"
import useToggleStates from "@src/hooks/useToggleStates"
import { formatProductGroups } from "../helpers"

const FiltersToggleButton = ({
  allProductGroups,
  selectedProductGroup,
  searchItem,
}) => {
  const { setContent, setSettings } = useSidebarStore(["setContent", "setSettings"])

  const { toggleAllFunction } = useToggleStates()

  const handleClick = () => {
    toggleAllFunction("sidebar", true)

    setContent(
      <SidebarContent>
        {searchItem && <ProductFilter query={searchItem} />}
        {formatProductGroups(allProductGroups, selectedProductGroup)?.map((group, index) => (
          <ProductFilter
            key={index}
            group={group}
            selectedGroup={selectedProductGroup}
          />
        ))}
      </SidebarContent>
    )

    setSettings({ showSearchBar: false })
  }

  return (
    <Button
      arrow={"none"}
      ctaWidth={"full"}
      theme={"btn-secondary"}
      className={"category-filter-button md:hidden"}
      onClick={handleClick}
    >
      <div className="w-fit flex mx-auto justify-center items-center gap-x-2.5">
        Categories
        <Plus />
      </div>
    </Button>
  )
}

export default FiltersToggleButton
